import { Component, Input, OnInit } from '@angular/core';
import { Organization } from "../../../../model/organization";

@Component({
  selector: 'app-organization-overview',
  templateUrl: './organization-overview.component.html',
  styleUrls: ['./organization-overview.component.scss']
})
export class OrganizationOverviewComponent implements OnInit {

  @Input()
  public organization: Organization;
  
  constructor() { }

  ngOnInit(): void {
  }

}
